var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 57,
    viewBox: "0 0 67 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4034 16.3254V15.9688H13.2744V16.3254C13.2744 16.9353 13.2904 17.5453 13.3213 18.1521L15.4481 18.0435C15.4194 17.4718 15.4034 16.9002 15.4034 16.3254Z",
    fill: "url(#paint0_linear_617_14772)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6171 20.1094L13.502 20.351C14.1109 25.7129 15.9801 30.9535 18.9065 35.5043L20.697 34.3525C17.9463 30.0742 16.1909 25.1488 15.6171 20.1094Z",
    fill: "url(#paint1_linear_617_14772)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7386 5.55469C37.8949 6.80016 35.7371 7.45803 33.4995 7.45803C31.2619 7.45803 29.1052 6.80016 27.2615 5.55575L26.0703 7.32071C28.2675 8.80357 30.8361 9.58704 33.4995 9.58704C36.1629 9.58704 38.7316 8.80357 40.9298 7.31964L39.7386 5.55469Z",
    fill: "url(#paint2_linear_617_14772)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0806 36.1953H7.95155C7.95155 40.3032 4.60794 43.6469 0.5 43.6469V45.7759C4.60794 45.7759 7.95155 49.1195 7.95155 53.2274H10.0806C10.0806 49.1195 13.4242 45.7759 17.5321 45.7759V43.6469C13.4242 43.6469 10.0806 40.3032 10.0806 36.1953ZM9.01606 48.8576C8.10058 47.0799 6.64753 45.6269 4.8698 44.7114C6.64753 43.7959 8.10058 42.3428 9.01606 40.5651C9.93154 42.3428 11.3846 43.7959 13.1623 44.7114C11.3846 45.6269 9.93154 47.0799 9.01606 48.8576Z",
    fill: "url(#paint3_linear_617_14772)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0485 8.51606H57.0099C54.9938 3.50117 50.0587 0 44.4668 0C41.8269 0 39.3444 0.714285 37.2878 2.06408C35.0108 3.56291 31.9908 3.56291 29.7128 2.06408C27.6572 0.714285 25.1748 0 22.5337 0C15.08 0 9.0166 6.06344 9.0166 13.5171V16.3242C9.0166 23.9567 11.1988 31.3828 15.3259 37.8028C17.5465 41.2571 19.1773 45.0287 20.1737 49.0121L21.3319 53.6469C21.7385 55.2799 23.198 56.4189 24.8799 56.4189C26.7055 56.4189 28.2278 55.1085 28.4971 53.3031L30.8848 37.3802C31.0817 36.0762 32.1814 35.1288 33.5003 35.1288C34.8192 35.1288 35.9188 36.0762 36.1147 37.3802L38.5024 53.3031C38.7728 55.1085 40.295 56.4189 42.1207 56.4189C43.8026 56.4189 45.262 55.2799 45.6687 53.6469L46.8279 49.0121C47.8243 45.0276 49.4562 41.2561 51.6768 37.8028C54.1028 34.0281 55.8773 29.8126 56.9152 25.4375C56.9141 25.4747 56.9194 25.5109 56.9194 25.5482H59.0485C59.0485 21.4403 62.3921 18.0966 66.5 18.0966V15.9676C62.3921 15.9676 59.0485 12.624 59.0485 8.51606ZM49.8852 36.651C47.5379 40.3023 45.8156 44.2878 44.7628 48.4968L43.6025 53.1317C43.4332 53.8141 42.8232 54.2899 42.1207 54.2899C41.3574 54.2899 40.7219 53.7417 40.6091 52.9869L38.2214 37.064C37.868 34.7083 35.8816 32.9997 33.5003 32.9997C31.119 32.9997 29.1326 34.7083 28.7792 37.064L26.3915 52.9869C26.2797 53.7417 25.6431 54.2899 24.8799 54.2899C24.1773 54.2899 23.5674 53.8141 23.396 53.1317L22.2367 48.4968C21.185 44.2867 19.4616 40.3012 17.1143 36.651C13.2097 30.5759 11.1456 23.5469 11.1456 16.3242V13.5171C11.1456 7.23759 16.2542 2.12902 22.5337 2.12902C24.7575 2.12902 26.8354 2.72195 28.5429 3.84394C30.0342 4.82435 31.7034 5.32254 33.5003 5.32254C35.2972 5.32254 36.9663 4.82435 38.4566 3.84394C40.1652 2.72195 42.2431 2.12902 44.4668 2.12902C50.0832 2.12902 54.9288 6.3136 55.7272 11.7777L55.7719 12.4707C54.4519 14.5667 52.1228 15.9676 49.4679 15.9676V18.0966C51.9674 18.0966 54.1783 19.3378 55.5303 21.2316C54.8117 26.6904 52.8615 32.0204 49.8852 36.651ZM57.984 21.1784C57.0685 19.4007 55.6154 17.9476 53.8377 17.0321C55.6154 16.1166 57.0685 14.6636 57.984 12.8859C58.8994 14.6636 60.3525 16.1166 62.1302 17.0321C60.3525 17.9476 58.8994 19.4007 57.984 21.1784Z",
    fill: "url(#paint4_linear_617_14772)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_617_14772",
    x1: 13.2744,
    y1: 15.9688,
    x2: 15.5507,
    y2: 16.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_617_14772",
    x1: 13.502,
    y1: 20.1094,
    x2: 21.051,
    y2: 20.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_617_14772",
    x1: 26.0703,
    y1: 5.55469,
    x2: 41.1617,
    y2: 8.32291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_617_14772",
    x1: 0.5,
    y1: 36.1953,
    x2: 18.3357,
    y2: 37.0831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_617_14772",
    x1: 9.0166,
    y1: 0,
    x2: 69.2066,
    y2: 3.0526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDental);
export default __webpack_public_path__ + "static/media/icon-dental.72881f3b65b540bd8e1ed442d0b26c7e.svg";
export { ForwardRef as ReactComponent };